<template>
  <div id="ag-grid-demo">
    <!-- <p>{{ tab }}</p> -->

    <div class="pl-2">
      <div
        class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
      >
        <div class="mb-2">
          <vs-button
            :color="bermuda"
            v-if="
            page.table.filter_button !== undefined &&
              page.table.filter_button.value !== undefined &&
                page.table.filter_button.value !== null
            "
            class="mr-3"
            @click="openModal()"
            >Filter</vs-button
          >
          <vs-button
            :color="bermuda"
            v-if="page.table.add_button.value"
            :href="page.table.add_button.to"
            >{{ page.table.add_button.name }}</vs-button
          >
        </div>
        <vs-input
          class="mb-4 md:mb-0 mr-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
      </div>

      <div class="mt-4">
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left"></div>

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        </div>

        <tab-component></tab-component>
        <ag-grid-vue
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 ag-grid-table"
          :columnDefs="page.table.column"
          :defaultColDef="defaultColDef"
          :rowData="page.table.data"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl"
          @first-data-rendered="onFirstDataRendered"
          @rowDataChanged="onrowDataChanged"
          :setQuickFilter="updateSearchQuery"
          @gridReady="onGridReady"
          :enableCellTextSelection="true"
        >
        </ag-grid-vue>

       
        <vs-pagination
          :total="totalPages"
          :max="maxPageNumbers"
          v-model="currentPage"
        /> 
      </div>
      <!-- <pagination
        class="mt-3"
        v-model="page_num"
        :per-page="10"
        :records="page.total"
        @paginate="ChangePage"
      /> -->
    </div>

    <div>
      <!-- <b-button v-b-modal.modal-1>Launch demo modal</b-button> -->

      <b-modal
        id="modal-1"
        center
        style="margin-top: 40%;"
        title="Add new admin"
        modal-header="No"
      >
        <b-row class="py-3">
          <b-col cols="3" class="text-center mt-1"> Username</b-col>
          <b-col cols="9" class="text-left">
            <b-form-input
              v-model="username"
              placeholder="Username"
            ></b-form-input
          ></b-col>
        </b-row>
        <b-row class="py-3">
          <b-col cols="3" class="text-center mt-1"> Password</b-col>
          <b-col cols="9" class="text-left">
            <b-form-input
              v-model="password"
              placeholder="Password"
            ></b-form-input
          ></b-col>
        </b-row>
        <b-row class="py-3">
          <b-col cols="3" class="text-center mt-1"> Name</b-col>
          <b-col cols="9" class="text-left">
            <b-form-input v-model="name" placeholder="Name"></b-form-input
          ></b-col>
        </b-row>
        <b-row class="py-3">
          <b-col cols="3" class="text-center mt-1"> Role</b-col>
          <b-col cols="9" class="text-left">
            <b-form-input v-model="role" placeholder="Role"></b-form-input
          ></b-col>
        </b-row>
        <template #modal-footer="{ ok, cancel }">
          <!-- <b>Custom Footer</b> -->
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button class="btn-primary" @click="ok()">
            ตกลง
          </b-button>
          <b-button class="btn-gery" @click="cancel()">
            ยกเลิก
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>

        <!-- <p class="my-4">Hello from modal!</p> -->
      </b-modal>
    </div>

    <!-- filter Modal -->
    <b-modal
      id="filter_button"
      title="Filter"
      @ok="filterHadler"
      @cancel="clearfilter"
      cancel-title="ล้าง"
      ok-title="ค้นหา"
      v-if="page.table.filter_button !== undefined &&
            page.table.filter_button.value !== undefined &&
            page.table.filter_button.value !== null"
    >
      <div
        v-for="(item, index) in page.table.filter_button.column"
        :key="index"
      >
        <b-row>
          <b-col cols="12">
            {{ item.name }}
            <b-form-select v-model="columnFilter[index]" class="mb-3">
              <b-form-select-option
                v-for="(i, index) in item.filter"
                :key="index"
                :value="i.url"
                >{{ i.name }}</b-form-select-option
              >
            </b-form-select>
          </b-col>
        </b-row>
      </div>

      <!-- <p class="my-4">Vertically centered modal!</p> -->
    </b-modal>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import topButton from "../topTableButton/topTableButton";
import { mapGetters } from "vuex";
import iconDetail from "./table_component/iconDetail";
import iconDelete from "./table_component/iconDelete";
import tabComponent from "./../tabComponent/tabComponent";
import Dropdown from "./table_component/Dropdown";
import String from "./table_component/String";
import Date from "./table_component/Date";
import Float from "./table_component/Float";
import Number from "./table_component/Number";
import Array from "./table_component/Array";
import Publish from "./table_component/Publish";
import Edit from "./table_component/Edit";
import Delete from "./table_component/Delete";
import Datepicker from "vuejs-datepicker";
import TextInput from "./table_component/TextInput.vue";
import Success from "./table_component/Success.vue";
import DateTime from "./table_component/DateTime.vue";
import PopUpText from "./table_component/PopUpText.vue";
import PopUpBranch from "./table_component/PopUpBranch.vue";
import PopUpImage from "./table_component/PopUpImage.vue";

import moment from "moment";
import Pagination from "vue-pagination-2";

import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import themeConfig from "@/../themeConfig.js";

export default {
  components: {
    AgGridVue,
    Datepicker,
    iconDetail,
    iconDelete,
    tabComponent,
    topButton,
    Dropdown,
    String,
    Date,
    Float,
    Number,
    Publish,
    Array,
    Edit,
    Delete,
    TextInput,
    Success,
    DateTime,
    PopUpText,
    PopUpBranch,
    PopUpImage,
    Pagination,
  },
  data() {
    return {
      bermuda: null,
      searchQuery: "",
      gridOptions: { resizable: true, copyHeadersToClipboard: true },
      maxPageNumbers: 6,
      gridApi: "sizeColumnsToFit",
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
        flex: 1,
        minWidth: 120,
      },
      start_date: null,
      end_date: null,
      masks: {
        input: "YYYY-MM-DD",
      },
      username: null,
      password: null,
      name: null,
      role_choice: ["Admin", "Super Admin"],
      role: null,
      columnFilter: [],
      selectFilter: [],
      selectFilterCurrent: [],
      page_num: 1,
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("email", null);
      } else this.gridOptions.columnApi.setColumnPinned("email", "left");
    },
  },
  computed: {
    ...mapGetters({
      getTable: "general/table",
      nowPage: "getNowPage",
      page: "general/page",
    }),
    start_date_moment() {
      // console.log("start_date", this.start_date);
      const start_date = moment().format("YYYY-MM-01");
      return start_date;
    },
    end_date_moment() {
      // console.log("his.end_date", this.end_date);
      const end_date = moment().format("YYYY-MM-") + moment().daysInMonth();

      return end_date;
    },

    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 100;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    changeTabActive(index) {
      this.$store.dispatch("home/changeTabActive", index);
    },
    async onFirstDataRendered(params) {
      // params.api.sizeColumnsToFit();
      await this.autoSizeAll(false);
    },
    async onrowDataChanged(params){
      // params.api.sizeColumnsToFit();
      // console.log("onrowDataChanged");
      await this.autoSizeAll(false);
    },
    onGridReady() {
      this.gridApi = this.gridOptions.api;
      this.gridColumnApi = this.gridOptions.columnApi;
    },
    async autoSizeAll(skipHeader) {
      const allColumnIds = [];
      await this.gridOptions.columnApi.getAllColumns().forEach((column) => {
        allColumnIds.push(column.colId);
      });
      // console.log('allColumnIds',allColumnIds);

      await this.gridOptions.columnApi.autoSizeColumns(allColumnIds, skipHeader);
    },
    openModal() {
      this.$bvModal.show("filter_button");
    },

    async filterHadler() {
      let filterOption;
      for (let [index, filter] of this.columnFilter.entries()) {
        if (index == 0) {
          filterOption = (filterOption ? filterOption : "") + filter;
        } else {
          filterOption = (filterOption ? filterOption : "") + "&" + filter;
        }
      }

      this.selectFilter = filterOption;

      await this.$store.dispatch("general/getPage", {
        url: this.page.table.filter_button.url,
        filter: filterOption,
      });
      this.page_num = 1;
    },
    async ChangePage() {
      await this.$store.dispatch("general/getPage", {
        url: this.page.table.filter_button.url,
        filter: this.selectFilter,
      });
      // this.$router.push({ query: { page: this.page_num } });
    },
    async clearfilter() {
      await this.$store.dispatch("general/getPage", {
        url: this.page.table.filter_button.url,
        filter: null,
      });
      this.columnFilter = [];
      this.page_num = 1;
    },
  },
  created() {
    // this.start_date = new Date();
    // this.end_date = new Date(
    //   new Date().getFullYear(),
    //   new Date().getMonth() + 1,
    //   0
    // );
  },
  mounted() {
    console.log("page", this.page);
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.bermuda = themeConfig.theme.bermuda;

    this.page_num = this.$route.query.page ? this.$route.query.page : 1

    // this.$store.dispatch("home/getTabComponent");
  },
};
</script>
<style>
.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  outline: 0;
  top: 200px;
}
</style>
